import axios from 'axios';
import * as Sentry from '@sentry/browser';
import CitizenConfig from '../config';

export const REQUEST_ALBUM = 'REQUEST_ALBUM';
export const RECEIVE_ALBUM = 'RECEIVE_ALBUM';
export const INVALIDATE_ALBUM = 'INVALIDATE_ALBUM';

const API_ALBUM_URL_BASE_BACKUP = `${CitizenConfig.API_URL}/wp/v2/album/`;
// const API_ALBUM_URL_BASE = `/api/albums/`;
const API_ALBUM_URL_BASE = `${CitizenConfig.API_URL}/wp/v2/album/`;

function requestAlbum() {
  return {
    type: REQUEST_ALBUM
  };
}

function receiveAlbum(json) {
  if (
    json.code === 'rest_post_invalid_id' ||
    json.code === 'rest_not_logged_in'
  ) {
    return null;
  }

  return {
    type: RECEIVE_ALBUM,
    album: json.data,
    receivedAt: Date.now()
  };
}

function fetchAlbum(albumId, history) {
  return (dispatch, getState) => {
    let { user } = getState();
    dispatch(requestAlbum());

    return axios
      .get(`${API_ALBUM_URL_BASE}${albumId}`)
      .then((res) => {
        return dispatch(receiveAlbum(res));
      })
      .catch(err => {
        // try one more time with the fallback before giving up.
        // #cacheFallbacks
        console.warn(`Warning cache api is down: Using fallback url: ${API_ALBUM_URL_BASE_BACKUP}`);

        Sentry.captureException({
          type: `fetchAlbum where user ${user.authenticated ? 'is' : 'is not'} authenticated`,
          error: err
        });

        console.log(`${API_ALBUM_URL_BASE_BACKUP}${albumId}`)

        axios.get(`${API_ALBUM_URL_BASE_BACKUP}${albumId}`)
          .then(res => {
            return dispatch(receiveAlbum(res));
          })
      });
  };
}

function shouldFetchAlbum(state) {
  const posts = state;

  if (!posts.items) {
    return true;
  } else if (posts.isFetching) {
    return false;
  } else {
    return posts.didInvalidate;
  }
}

export function fetchAlbumIfNeeded(albumId, history) {
  return (dispatch, getState) => {
    if (shouldFetchAlbum(getState())) {
      return dispatch(fetchAlbum(albumId, history));
    }
  };
}


// WEBPACK FOOTER //
// ./src/actions/AlbumActions.js